var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
// pages
import Instamart from '@/pages/instamart';
import ExternalLogin from '@/pages/instamart/login';
import LoginSuccess from '@/pages/instamart/login/success';
import EmployeeLogin from '@/pages/instamart/employee-login';
import CampaignCreate from '@/pages/instamart/campaign/create';
import HomePage from '@/pages/instamart/home';
import CampaignEdit from '@/pages/instamart/campaign/edit';
import Campaign from '@/pages/instamart/campaign';
import CampaignDetailsLayout from '@/pages/instamart/campaign/details';
import CampaignDetailIndex from '@/pages/instamart/campaign/details/IndexPage';
import AccountSelect from '@/pages/instamart/account-select';
import SearchIndexPage from '@/pages/instamart/search';
import NotFound from '@/pages/instamart/404';
// layouts
import PrivateRoutes from '@/layouts/PrivateRoutes';
import PublicRoutes from '@/layouts/PublicRoutes';
import CoreLayout from '@/layouts/CoreLayout';
import LoginLayout from '@/layouts/LoginLayout';
// helpers
import { isUserAuthenticated } from '@/helpers/login';
// styles
import './App.scss';
export default function App() {
    const [init, setInit] = React.useState(false);
    const [isAuthenticated, setIsAuthenticated] = React.useState(false);
    useEffect(() => {
        (function () {
            return __awaiter(this, void 0, void 0, function* () {
                const authenticated = yield isUserAuthenticated();
                setIsAuthenticated(authenticated);
                setInit(true);
            });
        })();
    }, []);
    if (!init) {
        return null;
    }
    return (React.createElement(BrowserRouter, { basename: "/instamart" },
        React.createElement(CoreLayout, null,
            React.createElement(Routes, null,
                React.createElement(Route, { element: React.createElement(PrivateRoutes, { isAuthenticated: isAuthenticated, setAuthenticated: setIsAuthenticated }) },
                    React.createElement(Route, { element: React.createElement(Instamart, null) },
                        React.createElement(Route, { index: true, element: React.createElement(HomePage, null) }),
                        React.createElement(Route, { path: "account-select", element: React.createElement(AccountSelect, null) }),
                        React.createElement(Route, { path: "campaign", element: React.createElement(Campaign, null) },
                            React.createElement(Route, { path: "create", element: React.createElement(CampaignCreate, null) }),
                            React.createElement(Route, { path: "list", element: React.createElement(SearchIndexPage, null) }),
                            React.createElement(Route, { path: ":id", element: React.createElement(CampaignDetailsLayout, null) },
                                React.createElement(Route, { index: true, element: React.createElement(CampaignDetailIndex, null) }),
                                React.createElement(Route, { path: "edit", element: React.createElement(CampaignEdit, null) }))))),
                React.createElement(Route, { element: React.createElement(PublicRoutes, { isAuthenticated: isAuthenticated }) },
                    React.createElement(Route, { path: "login", element: React.createElement(LoginLayout, null,
                            React.createElement(ExternalLogin, { handleLoginSuccess: setIsAuthenticated })) }),
                    React.createElement(Route, { path: "employee-login", element: React.createElement(LoginLayout, null,
                            React.createElement(EmployeeLogin, null)) }),
                    React.createElement(Route, { path: "login/success", element: React.createElement(LoginSuccess, { handleLoginSuccess: setIsAuthenticated }) })),
                React.createElement(Route, { path: "*", element: React.createElement(NotFound, null) })))));
}
